<script setup lang="ts">
import {onLaunch, onShow, onHide} from "@dcloudio/uni-app";
import {useUserStore} from "@/store";

const userStore = useUserStore();

onLaunch((options) => {
  if (!options?.query?.token) {
    return uni.reLaunch({url: '/pages/404/404'});
  }

  userStore.setToken(options?.query?.token)
  uni.$isResolve();
});
onShow(() => {
  console.log("App Show");
});
onHide(() => {
  console.log("App Hide");
});
</script>
<style>
view{
  box-sizing: border-box;
}
</style>
